export default __webpack_public_path__ + "static/media/peep-50.76619546.svg";